import React, { useState, useContext, useEffect } from 'react'
import AdminContext from '../../../StateContext/Application';
import { AddExpense32, Cancel32, DeleteRed32, submit } from '../../../../../public/LoginImages/importimages';
const AddExpense = () => {
  const context = useContext(AdminContext);
  const { GetAllProjectList, AddExpenses } = context;
  const [projects, setProjects] = useState([]);
  const [formData, setFormData] = useState({
    projectName: '',
    userName: '',
    expenseType: '',
    amount: '',
    description: ''
  });
  const [expenses, setExpenses] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
const entriesPerPage = 5;
const totalPages = Math.ceil(expenses.length / entriesPerPage);
const paginatedExpenses = expenses.slice(
  (currentPage - 1) * entriesPerPage,
  currentPage * entriesPerPage
);

  useEffect(() => {
    GetProjects();
  }, [])
  const GetProjects = async () => {
    try {
      let data = await GetAllProjectList();
      setProjects(data);
    } catch (error) {
      console.error("Error in GetProjects:", error);
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    if (
      formData.projectName &&
      formData.userName &&
      formData.expenseType &&
      formData.amount &&
      formData.description
    ) {
      setExpenses(prev => [...prev, formData]);
      setFormData({
        projectName: '',
        userName: '',
        expenseType: '',
        amount: '',
        description: ''
      });
    } else {
      alert('Please fill all fields!');
    }
  };
  const getTotalAmount = () => {
    return expenses.reduce((total, entry) => total + parseFloat(entry.amount || 0), 0);
  };
  const handleRemove = (indexToRemove) => {
    setExpenses(prev => prev.filter((_, index) => index !== indexToRemove));
  };

  const handleSave = async () => {
    if (expenses.length === 0) {
      alert('No data to save!');
      return;
    }
    let data = await AddExpenses(expenses, "insert");
    console.log(data.message);
    alert(data.message);
    window.location.reload();
  }
  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center', height: '2.5rem', background: 'linear-gradient(to Right, #B2E0F2 , #B7D7EA , #B2D1E6 , #C4C5E2 )', }}>
        <h5 className='mx-5 ' style={{ background: 'linear-gradient(to bottom, #3b409e, #0067ab, #0f79ba, #0098d5)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', fontWeight: '700', padding: '10px' }}> Add Expense</h5></div>
      <div style={{ backgroundColor: '#f4f7fe', backgroundSize: 'cover', width: '82vw', alignSelf: 'center', display: 'grid', justifyContent: "center", padding: '1rem', position: "relative", backdropFilter: 'blur(10px)', maxHeight: '85vh', overflowY: 'auto' }}>
        <div style={{ display: "grid", justifyContent: "center" }}>
          <div style={{ backgroundColor: 'rgb(255,255,255,0.8)', borderRadius: '20px' }}>
            <div style={{ display: 'flex', justifyContent: 'center', padding: '2rem' }}>
              <div style={{ backgroundColor: '#f4f7fe', borderRadius: '20px', paddingBottom: '15px' }}>
                <div style={{ display: 'flex' }}>
                  {/* Project Select */}
                  <div className="mx-3 my-1" style={{ width: "29rem" }}>
                    <label className="form-label col-4" >Select Project</label>
                    <select
                      style={selectStyle}
                      className="form-select"
                      name="projectName"
                      value={formData.projectName}
                      onChange={handleChange}
                    >
                      <option disabled value="">Select Project</option>
                      {projects.map((e) => (
                        <option key={e.ProjectName} value={e.ProjectName}>
                          {e.ProjectName}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* User Name */}
                  <div className="mx-3 my-1" style={{ width: "29rem" }}>
                    <label className="form-label col-4" style={labelStyle}>Name Of User</label>
                    <input
                      className="form-control"
                      type="text"
                      name="userName"
                      placeholder="Name Of User"
                      value={formData.userName}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div style={{ display: 'flex' }}>
                  {/* Project Select */}
                  <div className="mx-3 my-1" style={{ width: "29rem" }}>
                    <label className="form-label col-4" >Select Expense</label>
                    <select
                      style={selectStyle}
                      className="form-select"
                      name="expenseType"
                      value={formData.expenseType}
                      onChange={handleChange}
                    >
                      <option disabled value="">Select Expense Type</option>
                      <option>Salary Advance</option>
                      <option>Material Purchase</option>
                      <option>Food Allowance</option>
                      <option>Travelling</option>
                      <option>Local Transport</option>
                      <option>Water Tankers</option>
                      <option>Others</option>
                    </select>
                  </div>
                  {/* Amount */}
                  <div className="mx-3 my-1" style={{ width: "29rem" }}>
                    <label className="form-label col-4" >Enter Amount</label>
                    <input
                      className="form-control"
                      type="number"
                      name="amount"
                      placeholder="Enter Amount"
                      value={formData.amount}
                      onChange={handleChange}
                    />
                  </div>

                </div>

                {/* Description */}
                <div style={{ display: 'flex' }}>
                  {/* Project Select */}
                  <div className="mx-3 my-1" style={{ width: "29rem" }}>
                    <label className="form-label col-4">Enter Description</label>
                    <input
                      className="form-control"
                      type="text"
                      name="description"
                      placeholder="Enter Description"
                      value={formData.description}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '1rem', paddingTop: '10px' }}>
                  <button style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: "20px", width: "10rem", height: "2.5rem", background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', border: 'none', fontSize: '17px', gap: '4px' }} onClick={handleSubmit}> <img src='' style={{ width: '1.2rem', paddingBottom: '3px', fontSize: '15px' }} /><img  style={{ filter: 'invert(1) brightness(3)', width: '1.2rem'}}/> Add Expense</button>
                  <button style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: "20px", width: "7rem", height: "2.5rem", backgroundColor: '#E63E23', border: 'none', fontSize: '17px', gap: '4px' }}><img src={Cancel32} style={{ width: '1.2rem', paddingBottom: '3px', fontSize: '15px' }} /> Cancel</button>
                </div>
              </div>
            </div>
          </div>
        </div>
     

      {/* Submit Button */}


      {/* Table Section */}
      <div style={{ padding: '0 2rem' }}>
        {paginatedExpenses.length > 0 && (
          <>
            <div style={{ display: 'grid', justifyContent: 'center', padding: "20px 0px 0px 0px" }}>
              <div style={{ display: 'grid', justifyContent: 'center', width: '75vw', borderRadius: '20px', backgroundColor: 'white', padding: '2rem', }}>
                <h5 style={{ background: 'linear-gradient(to bottom, #3b409e, #0067ab, #0f79ba, #0098d5)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', fontWeight: '700', }}>Add Expense List</h5>
                <div style={{ display: 'flex', justifyContent: 'center', width: '70vw', backgroundColor: '#e8f7f3', border: '1px solid darkgray' }}>
                  <table style={{ backgroundColor: '#e8f7f3', width: '100%' }}>
                    <thead>
                      <tr style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', height: '2.5rem' }}>
                        <th>#</th>
                        <th>Project Name</th>
                        <th>User Name</th>
                        <th>Expense Type</th>
                        <th>Amount</th>
                        <th>Description</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {expenses.map((entry, idx) => (
                       <tr key={idx} style={{ backgroundColor: idx % 2 === 0 ? '#F4F7FE' : '#f0f8ff' }}>

                          <td>{idx + 1}</td>
                          <td>{entry.projectName}</td>
                          <td>{entry.userName}</td>
                          <td>{entry.expenseType}</td>
                          <td>₹{entry.amount}</td>
                          <td>{entry.description}</td>
                          <td style={{padding:'5px'}}>
                            <button
                              className="btn btn-custom-delete" style={{ width: '6rem', border: '1px solid #ee5d50', backgroundColor: 'white', borderRadius: '5px', padding: '5px', marginLeft: '10px', color: '#ee5d50', fontSize: '14px', fontWeight: '700' }}
                              onClick={() => handleRemove(idx)}
                            ><img className="icon-delete"
                              src={DeleteRed32}
                              style={{ width: '1.3rem', paddingBottom: '0.2rem' }}/>
                              Remove
                            </button>
                          </td>
                        </tr>
                      ))}
                      {/* Total row */}
                      <tr style={{height:'2rem'}}>
                        <td colSpan="4"> <strong>Total</strong></td>
                        <td colSpan="1"><strong>₹{getTotalAmount()}</strong></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div style={{display:'flex',justifyContent:'space-between',paddingTop:'10px', textAlign: 'center', marginBottom: '2rem' }}>
             <div>
             <button style={{ backgroundColor:'#0D7EBF',width:'9rem',height:'2rem',borderRadius:'20px',fontSize:'15px'}} onClick={handleSave}><img src={submit}style={{width:'16px'}}/> Save Expenses
              </button>
             </div>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                    {/* First Page Button */}
                    <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1}
                        style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0 }}>
                        &laquo;
                    </button>
                    {/* Previous Button */}
                    <button
                        onClick={() => setCurrentPage(currentPage - 1)}
                        disabled={currentPage === 1}
                        style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}>
                        &lt;
                    </button>

                    <button
                        style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', cursor: 'pointer', fontSize: '24px', width: '3rem', margin: 0, borderRadius: 0, border: '1px solid lightgrey', borderLeft: "none" }}>{currentPage}
                    </button>
                    {/* Next Button */}
                    <button
                        onClick={() => setCurrentPage(currentPage + 1)}
                        disabled={currentPage === totalPages}
                        style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}>
                        &gt;
                    </button>
                    {/* Last Page Button */}
                    <button
                        onClick={() => setCurrentPage(totalPages)}
                        disabled={currentPage === totalPages}
                        style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}>
                        &raquo;
                    </button>
                </div>
            </div>
          </>

        )}
      </div>
      </div>
    </>
  );
};

const cardStyle = {
  margin: "1rem",
  display: 'flex',
  width: '30vw',
  border: 'none',
  padding: '15px',
  background: 'linear-gradient(to Right, #B2E0F2 , #B7D7EA , #B2D1E6 , #C4C5E2 )',
  borderRadius: '10px'
};

const labelStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  fontWeight: '600'
};

const selectStyle = {
  boxShadow: '0px 0px 4px'
};

export default AddExpense